var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-create',_vm._g(_vm._b({attrs:{"title":_vm.$t('users.form.add'),"name":"users-create"}},'base-create',_vm.$attrs,false),_vm.$listeners),[_c('users-form',{attrs:{"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }